import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const normalizeValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch (error) {
      return "-";
    }
  }
  return String(value);
};

const ReworkRequestsDialog = ({
  open,
  reworkRequests,
  onClose,
  onContinue,
  onRequestClick,
}) => {
  const rows = Array.isArray(reworkRequests) ? reworkRequests : [];
  const columns = rows.length > 0 ? Object.keys(rows[0]) : [];
  const isRequestIdColumn = (columnName) => {
    const normalized = String(columnName || "")
      .toLowerCase()
      .replace(/\s/g, "")
      .replace(/_/g, "");
    return normalized === "requestid";
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      aria-labelledby="rework-requests-title"
    >
      <DialogTitle id="rework-requests-title" sx={{ fontFamily: "Verdana" }}>
        Pending Rework Requests
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{
            fontFamily: "Verdana",
            fontSize: "14px",
            color: "#212F37",
            marginBottom: "12px",
          }}
        >
          You have pending rework requests. Please review them before creating a
          new part.
        </Typography>

        <TableContainer
          component={Paper}
          sx={{ maxHeight: "420px", border: "1px solid #E0E0E0" }}
        >
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column}
                    sx={{
                      fontFamily: "Verdana",
                      fontWeight: 700,
                      color: "#C6003D",
                      background: "#FAF0F0",
                      borderBottom: "1px solid #BDBDBD",
                    }}
                  >
                    {column
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (char) => char.toUpperCase())}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, rowIndex) => (
                <TableRow key={`rework-row-${rowIndex}`}>
                  {columns.map((column) => (
                    <TableCell
                      key={`${rowIndex}-${column}`}
                      sx={{
                        fontFamily: "Verdana",
                        borderBottom: "1px solid #ECECEC",
                      }}
                    >
                      {isRequestIdColumn(column) && row?.[column] ? (
                        <button
                          type="button"
                          onClick={() => onRequestClick?.(row?.[column], row)}
                          style={{
                            border: "0px",
                            padding: 0,
                            background: "transparent",
                            color: "#C6003D",
                            cursor: "pointer",
                            fontWeight: 600,
                            fontFamily: "Verdana",
                            textDecoration: "underline",
                          }}
                        >
                          {normalizeValue(row?.[column])}
                        </button>
                      ) : (
                        normalizeValue(row?.[column])
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions sx={{ padding: "16px 24px" }}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            borderColor: "#C6003D",
            color: "#C6003D",
            fontFamily: "Verdana",
            textTransform: "none",
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onContinue}
          sx={{
            background: "#C6003D",
            fontFamily: "Verdana",
            textTransform: "none",
            "&:hover": { background: "#AA0034" },
          }}
        >
          Continue To Create Part
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReworkRequestsDialog;
